/**
 * SpeechRecognition container
 * Using Chrome SpeechRecognition dependency and converting voice input into text message as the query in the Search box
 * In the local, the microphone will be BLOCLED, and only can be tested in the stage or Live
 * Local mock test: Add search query manually to simulater onresult event
 * recognitionStart() {
     this.recognition.start();
     this.props.startRecording();
     this.props.speechRecognitionRequest('money');
     this.redirectSearchPage('money');
     this.props.endRecording();
   }
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { soundEndRecording, soundStartRecording } from '../actions/action-speech-recognition';

class SpeechRecognition extends Component {
  constructor(props) {
    super(props);

    this.recognitionStart = this.recognitionStart.bind(this);
    this.recognitionStop = this.recognitionStop.bind(this);

    try {
      // define recognition; only for Chrome Browser
      const Speech = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (typeof Speech === 'undefined') {
        return null;
      }

      // TODO: extend recognition grammer or language in the future
      this.recognition = new Speech();
      this.recognition.lang = 'en-US';
      this.recognition.interimResults = false;
      this.recognition.maxAlternatives = 1;

      // TODO: placeholder additional event handler; add onstart, onspeechend, onerror event handler

      // Speech onresult event handler
      this.recognition.onresult = (event) => {
        const current = event.resultIndex;

        // Get a transcript of what was said.
        const transcript = event.results[current][0].transcript;
        const mobileRepeatBug = (current === 1 && transcript === event.results[0][0].transcript);

        if (!mobileRepeatBug) {
          // the get speech result, and should send to search box
          this.props.onResult(transcript);
        }

        // Automatically stop recognition, when received result
        this.props.onEnd();
        this.recognition.stop();
      };

      this.recognition.onsoundstart = () => {
        // may be reset or default it
        this.props.soundStartRecording();
      };

      this.recognition.onsoundend = () => {
        // on sound end we should intimate that we are listening
        this.props.soundEndRecording();
      };
    } catch (error) {
      // on sound end we should intimate that we are listening
      this.props.onError(error);
    }
  }

  componentDidUpdate(prevProps) {
    let autoTerminate;

    // SpeechRecognition will be automatically terminate after 5 second without receiving voice input
    if (!prevProps.isRecording && this.props.isRecording) {
      autoTerminate = setTimeout(() => {
        this.recognitionStop();
      }, 5000);
    } else if (prevProps.isRecording && !this.props.isRecording) {
      clearTimeout(autoTerminate);
    }
  }

  // Speech tracking start
  recognitionStart() {
    this.recognition.start();
    this.props.onStart();
  }

  // Speech tracking end
  recognitionStop() {
    this.recognition.stop();
    this.props.onEnd();
  }

  render() {
    if (!this.props.display || !this.recognition) {
      return null;
    }

    const attr = {
      type: 'button',
    };

    attr.onClick = !this.props.isRecording ? this.recognitionStart : this.recognitionStop;
    attr.className = classNames({
      'speech-recognition': true,
      'speech-recognition__start': !this.props.isRecording,
      'speech-recognition__end': this.props.isRecording,
    });

    return (
      <button {...attr} />
    );
  }
}

SpeechRecognition.propTypes = {
  display: PropTypes.bool,
  isRecording: PropTypes.bool,
  onStart: PropTypes.func,
  onEnd: PropTypes.func,
  onResult: PropTypes.func,
  onError: PropTypes.func,
  soundStartRecording: PropTypes.func,
  soundEndRecording: PropTypes.func,
};

SpeechRecognition.defaultProps = {
  display: true,
  isRecording: false,
  onStart: () => {},
  onEnd: () => {},
  onResult: () => {},
  onError: () => {},
  soundStartRecording: () => {},
  soundEndRecording: () => {},
};

function mapStateToProps(state) {
  return {
    isRecording: state.speechRecognition.isRecording,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ soundEndRecording, soundStartRecording }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SpeechRecognition);
